import ListaMaterias from '../../Utils/Selectores/Materias/listaMaterias';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import React, { useState ,useEffect} from 'react';
import AddMateria from '../../../views/Utils/Selectores/Materias/addMateria';
import LoadingWidget from '../../../components/Loadings/LoadingWidget';

const AgregarVariables = () => {

  const {
      universidades,
      universidadesOptions,
      isLoadingUniversidad,
      erroruniversidades,
      cargarUniversidades,

      carreras,
      carrerasOptions,
      isLoadingCarreras,
      errorCarreras,
      cargarCarreras,

      materias,
      materiasOptions,
      isLoadingMaterias,
      errorMaterias,
      cargarMaterias,


  } = useListasModel();

  useEffect(() =>{
    cargarUniversidades();
    cargarCarreras();
    cargarMaterias();
  }, []);
  
  const addMateria = () =>{

  }

  if(isLoadingMaterias){
    return(
      <LoadingWidget
        mensaje={'Cargando materias'}
      />
    );
  }

  return (
    <div>
      agregar variables
      universidades{universidades.length}
      carreras{carreras.length}
      materias {materias.length}

      NUEVA MATERIA
      <AddMateria
        onAdd={addMateria}
        materias={materias}
      />

       <ListaMaterias
          materias={materias}
      />

      NUEVA CARRERA

      NUEVA UNIVERSIDAD

      EDICION DE ASESORIAS

      EDICION DE MATERIA



    </div>
  );

}

export default AgregarVariables
